import Vue from 'vue';

const STORAGE_KEY = 'janguask_store';

// Default initial state
const initialState = {
  isLoggedIn: false,
  currentUser: {
    name: '',
    email: '',
    school: '',
    avatar: '',
  },
  stats: {
    quizzes: 0,
    score: 0,
    groups: 0
  },
  feedPosts: [
    {
      id: "p1",
      publisher: "Dr. Amina Bello",
      university: "Ahmadu Bello University, Zaria",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      duration: "09:56",
      date: "2 hours ago",
      views: "2.4k",
      likes: 156,
      comments: 43,
      caption: "🔬 Fluid Dynamics & Engineering Marvels — This visual demonstration explains complex thermodynamic concepts using real-world examples. Perfect for engineering students!",
      videoSrc: "/rdb.mp4",
      type: 'video'
    },
    {
      id: "p2",
      publisher: "Prof. Ibrahim Musa",
      university: "Bayero University, Kano",
      avatar: "https://randomuser.me/api/portraits/men/55.jpg",
      duration: "12:14",
      date: "4 hours ago",
      views: "1.8k",
      likes: 89,
      comments: 27,
      caption: "🎬 Computer Science & Programming — Foundational concepts every undergraduate CS student must know. From algorithms to data structures.",
      videoSrc: "/rdb.mp4",
      type: 'video'
    },
    {
      id: "p3",
      publisher: "Science Department",
      university: "University of Lagos",
      avatar: "https://randomuser.me/api/portraits/women/68.jpg",
      duration: "09:56",
      date: "1 day ago",
      views: "5.1k",
      likes: 312,
      comments: 95,
      caption: "🎥 Introduction to Physics — Understanding motion, forces, and energy transfer. Recommended for SS1–SS3 and UTME candidates.",
      videoSrc: "/rdb.mp4",
      type: 'video'
    },
    {
      id: "p4",
      publisher: "Mr. Yusuf Aliyu",
      university: "Federal University of Technology, Minna",
      avatar: "https://randomuser.me/api/portraits/men/22.jpg",
      duration: "06:32",
      date: "2 days ago",
      views: "980",
      likes: 67,
      comments: 18,
      caption: "🐘 Big Data & Machine Learning — A foundational lecture on data pipelines for Computer Science and Data Engineering students.",
      videoSrc: "/rdb.mp4",
      type: 'video'
    },
    {
      id: "p5",
      publisher: "Grace Okafor",
      university: "University of Ibadan",
      avatar: "https://randomuser.me/api/portraits/women/65.jpg",
      duration: "05:14",
      date: "3 days ago",
      views: "3.2k",
      likes: 204,
      comments: 56,
      caption: "⚗️ Introduction to Organic Chemistry — Practical demonstrations of common reactions including esterification and saponification for SS3 & UTME students.",
      videoSrc: "/rdb.mp4",
      type: 'video'
    },
    {
      id: "p6",
      publisher: "Dr. Suleiman Adamu",
      university: "Usman Dan Fodio University, Sokoto",
      avatar: "https://randomuser.me/api/portraits/men/77.jpg",
      duration: "14:22",
      date: "4 days ago",
      views: "1.1k",
      likes: 88,
      comments: 31,
      caption: "📐 Geometry & Coordinate Planes — Full walkthrough of coordinate geometry for WAEC and JAMB, including distance, midpoint, and gradient formula.",
      videoSrc: "/rdb.mp4",
      type: 'video'
    },
    {
      id: "p7",
      publisher: "Fatima Usman",
      university: "Obafemi Awolowo University, Ile-Ife",
      avatar: "https://randomuser.me/api/portraits/women/28.jpg",
      duration: "08:45",
      date: "5 days ago",
      views: "7.8k",
      likes: 534,
      comments: 122,
      caption: "🏃 Biomechanics & Human Physiology — Understanding muscular force, joint movement, and energy expenditure. Key topic for Biology and Physical Education students.",
      videoSrc: "/rdb.mp4",
      type: 'video'
    }
  ],
  discussions: [
    {
      subject: "Mathematics",
      level: "Senior Secondary",
      title: "How many numbers between 75 and 500 are divisible by 7?",
      content: "I'm trying to prepare for my upcoming WAEC exams and this arithmetic progression question has been confusing me. I know the formula for the nth term is Tn = a + (n-1)d, but how do I find 'n'?",
      tags: ["Arithmetic Progression", "WAEC", "Algebra"],
      author: "Mubarak Ibrahim",
      avatar: "https://randomuser.me/api/portraits/men/22.jpg",
      timeAgo: "2 hours ago",
      applauds: 45,
      comments: 12,
      hasImage: true
    },
    {
      subject: "Computer Science",
      level: "Tertiary",
      title: "Difference between Process and Thread in OS?",
      content: "Could someone explain in simple terms the main differences between a process and a thread? Which one shares memory and which one has its own address space?",
      tags: ["Operating Systems", "Programming", "Concurrency"],
      author: "Grace Okafor",
      avatar: "https://randomuser.me/api/portraits/women/65.jpg",
      timeAgo: "5 hours ago",
      applauds: 128,
      comments: 34,
      hasImage: false
    }
  ],
  groupChats: [
    {
      isMe: false,
      sender: "Mukhtar Yarima",
      avatar: "https://randomuser.me/api/portraits/men/45.jpg",
      time: "8:04 AM",
      text: "Did anyone understand the last topic on Cost Accounting? The lecturer was too fast."
    }
  ]
};

// Load from local storage or use initial state
let savedState = null;
try {
  const item = localStorage.getItem(STORAGE_KEY);
  if (item) {
    savedState = JSON.parse(item);
  }
} catch (e) {
  console.error("Could not load state", e);
}

// Create reactive state
export const state = Vue.observable(savedState || JSON.parse(JSON.stringify(initialState)));

// Methods to mutate state
export const store = {
  save() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  },

  login(email) {
    // Dummy login, assume user exists if logging in, otherwise use defaults
    state.isLoggedIn = true;
    if (!state.currentUser.name) {
      state.currentUser.name = email.split('@')[0];
      state.currentUser.email = email;
    }
    this.save();
  },

  signup(user) {
    state.isLoggedIn = true;
    state.currentUser = {
      name: user.fullName,
      email: user.email,
      school: user.school || 'Not specified',
      avatar: '' // Empty so it generates initials
    };
    // Reset stats for new user
    state.stats = { quizzes: 0, score: 0, groups: 0 };
    this.save();
  },

  logout() {
    // Clear all user data from localStorage
    localStorage.removeItem(STORAGE_KEY);
    // Reset state to initial values
    const fresh = JSON.parse(JSON.stringify(initialState));
    Object.assign(state, fresh);
  },

  addPost(post) {
    state.feedPosts.unshift(post);
    this.save();
  },

  addDiscussion(discussion) {
    state.discussions.unshift(discussion);
    this.save();
  },

  addChatMessage(message) {
    state.groupChats.push(message);
    this.save();
  },

  likePost(id) {
    const post = state.feedPosts.find(p => p.id === id);
    if (post) {
      post.likes++;
      this.save();
    }
  },

  addComment(id, text) {
    const post = state.feedPosts.find(p => p.id === id);
    if (post) {
      if (typeof post.comments === 'number') {
        post.comments++;
      }
      if (!post.commentsList) Vue.set(post, 'commentsList', []);
      post.commentsList.push({
        user: state.currentUser.name || 'Student',
        avatar: this.getUserAvatar(),
        text: text,
        time: 'Just now'
      });
      this.save();
    }
  },

  // Helper to generate initials avatar
  getInitialsAvatar(name) {
    if (!name) return 'https://ui-avatars.com/api/?name=User&background=f69227&color=fff';
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=f69227&color=fff&size=128`;
  },

  // Get correct avatar (user uploaded or generated)
  getUserAvatar() {
    if (state.currentUser.avatar) return state.currentUser.avatar;
    return this.getInitialsAvatar(state.currentUser.name);
  }
};
